import {
  CREATE_UPDATE_USER_TABLE_LAYOUT,
  CREATE_UPDATE_USER_TABLE_LAYOUT_SUCCESS,
  CREATE_UPDATE_USER_TABLE_LAYOUT_FAILURE,
  GET_ALL_USER_TABLE_LAYOUTS,
  SET_ALL_USER_TABLE_LAYOUTS,
  SET_ALL_USER_TABLE_LAYOUTS_FAILURE,
  GET_USER_TABLE_LAYOUT_BY_ID,
  SET_USER_TABLE_LAYOUT_BY_ID,
  SET_USER_TABLE_LAYOUT_BY_ID_FAILURE
} from '../types';

// Create/Update User Table Layout
export const createUpdateUserTableLayout = (payload) => ({
  type: CREATE_UPDATE_USER_TABLE_LAYOUT,
  payload
});

export const createUpdateUserTableLayoutSuccess = (data) => ({
  type: CREATE_UPDATE_USER_TABLE_LAYOUT_SUCCESS,
  data
});

export const createUpdateUserTableLayoutFailure = (error) => ({
  type: CREATE_UPDATE_USER_TABLE_LAYOUT_FAILURE,
  error
});

// Get All User Table Layouts
export const getAllUserTableLayouts = (filters = {}) => ({
  type: GET_ALL_USER_TABLE_LAYOUTS,
  filters
});

export const setAllUserTableLayouts = (layouts, total) => ({
  type: SET_ALL_USER_TABLE_LAYOUTS,
  layouts,
  total
});

export const setAllUserTableLayoutsFailure = (error) => ({
  type: SET_ALL_USER_TABLE_LAYOUTS_FAILURE,
  error
});

// Get User Table Layout By ID
export const getUserTableLayoutById = (id) => ({
  type: GET_USER_TABLE_LAYOUT_BY_ID,
  id
});

export const setUserTableLayoutById = (layout) => ({
  type: SET_USER_TABLE_LAYOUT_BY_ID,
  layout
});

export const setUserTableLayoutByIdFailure = (error) => ({
  type: SET_USER_TABLE_LAYOUT_BY_ID_FAILURE,
  error
});

